import { createSafeContext } from '@/util';

import type { VThemeContextValue } from './type';

export const VThemeContext = createSafeContext<VThemeContextValue>(
  null,
  'VThemeContext',
);
